import { observer } from "mobx-react-lite"
import { useSwitchChain } from "wagmi"
import { base } from "wagmi/chains"

import { Button } from "@/components/button"
import { useScaleApplication } from "@/domains/application/use-scale-application"

export const WrongChainPopup = observer(() => {
  const scaleApp = useScaleApplication()
  const { switchChain } = useSwitchChain()

  const wallet = scaleApp.Wallet

  if (!wallet.Connection.isConnected) {
    return null
  }

  if (wallet.Connection.currentChainId !== base.id) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
        <div className="flex flex-col items-center rounded-lg bg-p400 p-8 text-center text-t100">
          <h2 className="mb-8 text-2xl font-bold">Wrong Chain Detected</h2>

          <Button variant="primary" onClick={() => switchChain({ chainId: base.id })}>
            Please switch to Base
          </Button>
        </div>
      </div>
    )
  }

  return null
})
